import { useEffect, useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { useCompanyContext } from '../../context/CompanyContext';
import ClaimsTableContainer from '../../features/insurance/claims/table/ClaimsTableContainer';
import FiltersMenu from '../../components/filters-menu/FiltersMenu';
import ClaimFilters, {
  ClaimFiltersOptions,
} from '../../features/insurance/claims/ClaimFilters';
import { FormProvider, useForm } from 'react-hook-form';
import { ClaimSummaryProvider } from '../../features/insurance/claims/ClaimContext';
import NewClaimDrilldown from '../../features/insurance/claims/drilldown/NewClaimDrilldown';
import ClaimReport from '../../features/insurance/claims/report/ClaimReport';
import ClaimReportHeader from '../../features/insurance/claims/report/ClaimReportHeader';
import { useRolesAccessContext } from '../../context/RolesAccessContext';
import { ClaimStatus } from '../../Interfaces/Insurance/Claim';
import ClaimParams from '../../features/insurance/claims/ClaimParams';
import { useSearchParams } from 'react-router-dom';

const Claim = () => {
  const { selectedCompany } = useCompanyContext();
  const prevSelectedCompanyRef = useRef<string | null>(null);
  const { rolesAcess } = useRolesAccessContext();
  const [showDrilldown, setShowDrilldown] = useState(false);
  const tableRef = useRef<HTMLDivElement | null>(null);
  const [searchParams] = useSearchParams();
  const methods = useForm<ClaimFiltersOptions>({
    defaultValues: {
      claimStatus: ClaimStatus.Active,
    },
  });
  const access = rolesAcess?.find((access) => access.report === 'claim');

  useEffect(() => {
    if (prevSelectedCompanyRef.current === null) {
      prevSelectedCompanyRef.current = selectedCompany?.id || null;
    } else if (prevSelectedCompanyRef.current !== selectedCompany?.id) {
      if (!searchParams.get('company')) {
        methods.reset();
      }
      prevSelectedCompanyRef.current = selectedCompany?.id || null;
    }
  }, [selectedCompany, methods, searchParams]);

  return (
    <div className="h-full flex flex-column">
      <ClaimSummaryProvider>
        <FormProvider {...methods}>
          <div className="flex flex-column gap-2 mx-3 mt-6 my-4">
            {access?.editable && selectedCompany?.isActive && (
              <div className="flex flex-row gap-2 justify-content-between">
                <Button
                  onClick={() => {
                    setShowDrilldown(true);
                  }}
                  className="ml-5 h-fit buttonBackground text-white border-0 text-xl w-fit py-3 px-3 radius-10px"
                >
                  New Entry
                </Button>
                <NewClaimDrilldown
                  visible={showDrilldown}
                  setVisible={setShowDrilldown}
                />
              </div>
            )}
          </div>
          <div className="flex flex-column gap-2 mx-3 mt-4">
            <div className="flex flex-row gap-2 justify-content-between">
              <div className="flex w-full justify-content-between gap-2">
                <FiltersMenu>
                  <ClaimFilters />
                </FiltersMenu>
                <ClaimReport elementRef={tableRef} />
              </div>
            </div>
          </div>
          <div className="mb-3 printBackground pdfDivFitContent" ref={tableRef}>
            <ClaimReportHeader />
            <ClaimsTableContainer />
          </div>
          <ClaimParams />
        </FormProvider>
      </ClaimSummaryProvider>
    </div>
  );
};

export default Claim;
